(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["html-block"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const htmlBlocks = document.querySelectorAll('.html-block-dynamic');
    
    htmlBlocks.forEach(block => {
      const availabilityElements = [];
      
      // Znajdź elementy z tekstem dostępności
      const walker = document.createTreeWalker(
        block,
        NodeFilter.SHOW_TEXT,
        null,
        false
      );

      let node;
      while (node = walker.nextNode()) {
        if (node.textContent.includes('Produkt dostępny') || 
            node.textContent.includes('Ostatnie sztuki') || 
            node.textContent.includes('Produkt niedostępny')) {
          availabilityElements.push(node.parentElement);
        }
      }

      // Nasłuchuj na zmianę wariantu
      document.addEventListener('variant:change', (event) => {
        if (event.detail && event.detail.variant && availabilityElements.length > 0) {
          const quantity = event.detail.variant.inventory_quantity || 0;
          const available = event.detail.variant.available;
          let text = '';

          if (!available) {
            text = 'Produkt niedostępny';
          } else if (quantity > 10) {
            text = 'Produkt dostępny w dużej ilości. Wysyłka jutro.';
          } else if (quantity > 0) {
            text = 'Ostatnie sztuki! Wysyłka jutro.';
          } else {
            text = 'Produkt niedostępny';
          }

          availabilityElements.forEach(el => {
            el.textContent = text;
          });
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
